import { stdObject } from "../../../../data/types/stdObject";

export const closeStationery = async (
  close: boolean | string = false,
  params: stdObject,
) => {
  const {
    staValues,
    setStaValues,
    setStationeryModal,
    setMsg,
    documentAction,
    openWindow,
    closeMsg,
  } = params;
  if (!close && staValues.updated) {
    setMsg("askToClose");
  } else {
    if ("action" in documentAction.current) {
      openWindow({
        msgName: "document",
        modalInfo: {
          doc: staValues.type,
          code: staValues.documentData[`COD${staValues.type}`],
          serie: staValues.documentData[`SER${staValues.type}`],
          mainColor: staValues.mainColor,
          type: staValues.sectionId,
          typeText: staValues.typeText,
        },
      });
      documentAction.current = {};
    } else {
      setStaValues({});
    }
    setStationeryModal("");
    closeMsg();
  }
};
